import { SurveyQuestionTagbox } from 'survey-react-ui';
import { invoke } from 'lodash';

import classNames from 'classnames';
import { IonLabel, IonNote } from '@ionic/react';

import { SurveyTagboxItem } from '../SurveyTagboxItem/SurveyTagboxItem';

import styles from '../../../styles/form.module.scss';
import tagbox from './SurveyTagbox.module.scss';

export class SurvayTagbox extends SurveyQuestionTagbox {
  protected renderItem(key: string, item: any): JSX.Element {
    return <SurveyTagboxItem key={key} question={this.question} item={item} />;
  }

  protected renderElement(): JSX.Element {
    const invalid = this.question.errors.some(({ visible }) => visible);

    return (
      <div className={classNames(styles.formControlInline)}>
        <IonLabel
          className={classNames(tagbox.label, {
            [tagbox.invalid]: invalid,
          })}
        >
          {this.question.title}
        </IonLabel>
        <div className={tagbox.container}>
          {this.question.choices.map((choice, index) => {
            return this.renderItem('item' + index, choice);
          })}
        </div>
        {invalid && (
          <IonNote slot="helper" className={tagbox.error}>
            {invoke(this.question, ['errors', 0, 'getText'])}
          </IonNote>
        )}
      </div>
    );
  }
}
